 @if (menuAbierto()) {
  <div class="overlay-movil" (click)="cerrarMenu()"></div>
}

<button class="btn-colapso-flotante" (click)="toggleColapso()">
    <mat-icon>{{ menuColapsado() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
  </button>
<button class="btn-modo-oscuro-flotante" type="button" (click)="toggleModoOscuro()" [matTooltip]="modoOscuro() ? 'Modo claro' : 'Modo oscuro'">
    <mat-icon>{{ modoOscuro() ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>

<nav class="menu-lateral"
      [class.abierto-movil]="menuAbierto()"
     [class.colapsado]="menuColapsado()"
>
 <div class="logo-contenedor">
    <img [src]="logoAMostrar()" alt="Logo Principal" class="liga-logo">
    
    @if (!menuColapsado() && (rolActivoSignal()?.escudoURL || liga?.appIcon)) {
      <img src="assets/images/TT-Logo-Americano.svg" class="logomini" />
    }
    
    @if (menuColapsado() && rolActivoSignal()?.escudoURL) {
        <!--img src="assets/images/TT-Logo-Americano.svg" class="logomini-colapsado" /-->
    }
  </div>

 <ul class="lista-opciones">
    @for (opcion of opcionesMenuFiltradas(); track opcion.nombre) { 
      <li>
        <a [routerLink]="opcion.hijos ? null : ['/', routesUrl.MAIN, opcion.ruta]"
           routerLinkActive="activo"
           class="nav-link"
           [queryParamsHandling]="opcion.preserveQueryParams ? 'preserve' : ''"
           (click)="opcion.hijos ? toggleMenu(opcion) : null">
          <mat-icon [svgIcon]="opcion.icono" class="menu-svg-icon"></mat-icon>
          <span class="nombre-opcion" *ngIf="!menuColapsado()">{{ obtenerNombreOpcion(opcion) }}</span>
          
          <span class="flecha" *ngIf="opcion.hijos && !menuColapsado()">{{ opcion.desplegado ? '▲' : '▼' }}</span>
        </a>

        <ul class="lista-hijos" *ngIf="opcion.hijos && opcion.desplegado && !menuColapsado()">
          @for (hijo of opcion.hijos; track hijo.nombre) {
            <li>
              <a [routerLink]="hijo.nietos ? null : '/' + routesUrl.MAIN + '/' + hijo.ruta"
                 routerLinkActive="activo"
                 class="nav-link sub-link"
                 (click)="hijo.nietos && !hijo.ruta ? toggleMenu(hijo) : null">
                @if (!hijo.icono) {<span class="punto-guia">●</span>}
                @if (hijo.icono) {<mat-icon [svgIcon]="hijo.icono" class="menu-svg-icon-hijo"></mat-icon>}
                <span class="nombre-opcion">{{ hijo.nombre }}</span>
                <span class="flecha" *ngIf="hijo.nietos && !menuColapsado()">{{ hijo.desplegado ? '▲' : '▼' }}</span>
              </a>

                <ul class="lista-nietos" *ngIf="hijo.nietos && hijo.desplegado && !menuColapsado()">
                  @for (nieto of hijo.nietos; track nieto.nombre) {
                    <li>
                      <a [routerLink]="'/' + routesUrl.MAIN + '/' + nieto.ruta"
                         routerLinkActive="activo"
                         class="nav-link sub-link"
                         [queryParamsHandling]="nieto.preserveQueryParams ? 'preserve' : ''">
                        @if (!nieto.icono) {<span class="punto-guia">●</span>}
                        @if (nieto.icono) {<mat-icon [svgIcon]="nieto.icono" class="menu-svg-icon-hijo"></mat-icon>}
                        <span class="nombre-opcion">{{ nieto.nombre }}</span>
                      </a>
                    </li>
                  }
                </ul>
            </li>
          }
        </ul>
      </li>
    }
  </ul>
</nav>